import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  @Input() currentLanguage!: Observable<string>;
  public termsLink = 'https://www.iaa.org.il/page/usage';
  public privacyLink = 'https://www.iaa.org.il/page/privacy';
  public yoavEmail='yoav@israntique.org.il';
  public mokediaaEmail= 'mokediaa@israntique.org.il'
}
